export const MERCHANT_TRANS_TYPE = Object.freeze({
    COLLECTION: 1,
    DISBURSEMENT: 2,
});

const MERCHANT_TRANS_TYPE_LABELS: Record<number, string> = {
    1: 'Merchant Collection',
    2: 'Merchant Disbursement',
};

export const getMerchantTransTypeLabel = (
    transType: number | string | null | undefined,
): string => {
    if (transType === null || transType === undefined || transType === '') {
        return '-';
    }

    return MERCHANT_TRANS_TYPE_LABELS[Number(transType)] ?? 'Unknown';
};
